import {PdfPreviewsCreationApiDto} from "./restModels";

export class PdfPreviewsCreationData {
	constructor(public readonly id: string) {
	}

	public static fromJson(json: PdfPreviewsCreationApiDto): PdfPreviewsCreationData {
		return new PdfPreviewsCreationData(json.id);
	}
}